<template lang="pug">
  .pane.user-comment(:class="objectClass")
    .pane__header.user-comment__header Ваш комментарий к заказу

    .pane__body.user-comment__body
      textarea.user-comment__textarea(v-model="comment" )
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';

export default {
  computed: {
    ...mapGetters('user', {isUserOk: 'getIsOk'}),
    ...mapGetters('comment', ['getComment']),
    objectClass() {
      return {
        'pane--closed': !this.isUserOk,
      }
    },
    comment: {
      get() {
        return this.getComment;
      },
      set(value) {
        this.setComment(value);
      },
    },
  },
  methods: {
    ...mapMutations('comment', ['setComment']),
  }
}
</script>

